import { withSentryReactRouterV6Routing } from "@sentry/react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { StatementSurveyWrapper } from "./views/statement_survey";
import { NextStatement } from "./views/next_statement";
import { LocalizationWrapper } from "./components/localization_wrapper";
import { useEffect } from "react";
import { DEFAULT_LOCALE } from "./locales";
import { apiClient } from "./client";
const SentryRoutes = withSentryReactRouterV6Routing(Routes);

export default function App() {
  const location = useLocation();
  useEffect(() => {
    // Scroll to the top if the page changes
    window.scrollTo({ top: 0, left: 0 });
  }, [location]);

  return (
    <>
      <SentryRoutes>
        <Route path="/" element={<Navigate to={`/${DEFAULT_LOCALE}`} />} />
        <Route path="/:locale" element={<LocalizationWrapper />}>
          <Route index element={<NextStatement />} />
          <Route
            path=":statement"
            element={<StatementSurveyWrapper apiClient={apiClient} />}
          />
          {/* Any path that should exist should go to root */}
          <Route path="*" element={<Navigate to={`/${DEFAULT_LOCALE}`} />} />
        </Route>
      </SentryRoutes>
    </>
  );
}
